/* Tabbladen. Progressieve verbetering: zonder dit bestand staat het eerste
   paneel open en zijn de andere via hun id bereikbaar. Haken zijn
   data-attributen, geen classes. */

(function () {
  'use strict';

  class Tabs extends HTMLElement {
    connectedCallback() {
      this.knoppen = [...this.querySelectorAll('[data-tab]')];
      this.panelen = [...this.querySelectorAll('[data-tab-panel]')];

      /* Losse dingen die met een tabblad meelopen maar er niet in staan: de
         knop "Bekijk alles" hoort naast de tabbladen en niet onder de
         producten, terwijl hij per tabblad naar een andere collectie wijst.
         Zo'n element draagt data-tab-extra met de id van zijn paneel. */
      this.extras = [...this.querySelectorAll('[data-tab-extra]')];

      if (!this.knoppen.length) return;

      this.knoppen.forEach((knop) => {
        knop.addEventListener('click', () => this.toon(knop.getAttribute('data-tab')));
      });

      // Pijltjes links en rechts door de tabbladen, zoals een tablist hoort.
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = this.knoppen.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        const stap = e.key === 'ArrowRight' ? 1 : -1;
        const n = this.knoppen.length;
        const doel = this.knoppen[((i + stap) % n + n) % n];
        doel.focus();
        this.toon(doel.getAttribute('data-tab'));
      });
    }

    toon(id) {
      this.knoppen.forEach((k) => {
        const aan = k.getAttribute('data-tab') === id;
        k.classList.toggle('is-actief', aan);
        k.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      this.panelen.forEach((p) => {
        p.hidden = p.id !== id;
      });
      this.extras.forEach((e) => {
        e.hidden = e.getAttribute('data-tab-extra') !== id;
      });
      const paneel = this.panelen.find((p) => p.id === id);
      if (paneel) laadRij(paneel.querySelector('[data-rail-laden]'));
    }
  }

  /* Tabbladen die later komen (product-rail: data-rail-laden). In rust na het laden ophalen, of
     meteen bij het kiezen van het tabblad. Mislukt het, dan probeert de volgende keer het opnieuw. */
  function laadRij(lijst) {
    if (!lijst || lijst.__laden) return;
    const url = lijst.getAttribute('data-rail-laden');
    if (!url) return;
    const aantal = parseInt(lijst.getAttribute('data-aantal'), 10) || 12;
    lijst.__laden = fetch(url, { credentials: 'same-origin' })
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = [...doc.querySelectorAll('.shopify-section > li')].slice(0, aantal);
        if (!items.length) throw new Error('leeg');
        items.forEach((li) => lijst.appendChild(document.importNode(li, true)));
        lijst.removeAttribute('data-rail-laden');
        document.dispatchEvent(new CustomEvent('hws:rij:geladen', { detail: { lijst } }));
      })
      .catch(() => { lijst.__laden = null; });
  }
  const laadAlles = () => document.querySelectorAll('[data-rail-laden]').forEach(laadRij);
  const rust = () => ('requestIdleCallback' in window ? window.requestIdleCallback(laadAlles, { timeout: 4000 }) : setTimeout(laadAlles, 1500));
  if (document.readyState === 'complete') rust();
  else window.addEventListener('load', rust, { once: true });

  if (!customElements.get('hws-tabs')) customElements.define('hws-tabs', Tabs);
})();
